enum VerificationError {
  EMAIL_DOES_NOT_EXIST = 'Given email does not exist.',
  EMAIL_ALREADY_VERIFIED = 'Email already verified.',
  EXPIRED_CODE = 'Verification code expired.',
  INVALID_CODE = 'Invalid verification code.',
  GENERIC = 'This action could not be completed due to an error.',
}

export default VerificationError;
